/* ============================================
   ALnoor Theme — Scroll Animations
   Smooth reveal on scroll with IntersectionObserver
   ============================================ */

(function () {
  'use strict';

  const animationClasses = [
    'scroll-animate',
    'scroll-fade-up',
    'scroll-fade-in',
    'scroll-fade-left',
    'scroll-fade-right',
    'scroll-scale'
  ];

  const selector = animationClasses.map((c) => '.' + c).join(', ');

  const reducedMotion = !window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
  const supportsObserver = 'IntersectionObserver' in window;

  /* Mark <html> as having JS-driven animations only when we'll actually run them.
     CSS uses this class to scope hidden states so non-JS / reduced-motion users
     always see content. */
  if (!reducedMotion && supportsObserver) {
    document.documentElement.classList.add('js-animations');
  } else {
    /* No animations: immediately mark all targets visible so any author-written CSS
       gated on .is-visible still resolves to the visible state. */
    function showAll() {
      document.querySelectorAll(selector).forEach((el) => el.classList.add('is-visible'));
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showAll);
    } else {
      showAll();
    }
    document.addEventListener('shopify:section:load', showAll);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  function observe() {
    document.querySelectorAll(selector).forEach((el) => {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });
  }

  /* Safety net: any element still hidden after 3s gets revealed regardless. */
  function safetyReveal() {
    document.querySelectorAll(selector).forEach((el) => {
      if (!el.classList.contains('is-visible')) {
        el.classList.add('is-visible');
        observer.unobserve(el);
      }
    });
  }
  setTimeout(safetyReveal, 3000);

  /* Initial observation */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* Re-observe on Shopify section load */
  document.addEventListener('shopify:section:load', observe);

  /* Add animation CSS dynamically — scoped to html.js-animations so content
     is visible by default for users without JS/animations. */
  const style = document.createElement('style');
  style.textContent = `
    .js-animations .scroll-fade-up {
      opacity: 0;
      transform: translateY(30px);
      transition: opacity 0.7s ease, transform 0.7s ease;
    }
    .js-animations .scroll-fade-up.is-visible {
      opacity: 1;
      transform: translateY(0);
    }

    .js-animations .scroll-fade-in {
      opacity: 0;
      transition: opacity 0.7s ease;
    }
    .js-animations .scroll-fade-in.is-visible {
      opacity: 1;
    }

    .js-animations .scroll-fade-left {
      opacity: 0;
      transform: translateX(-30px);
      transition: opacity 0.7s ease, transform 0.7s ease;
    }
    .js-animations .scroll-fade-left.is-visible {
      opacity: 1;
      transform: translateX(0);
    }

    .js-animations .scroll-fade-right {
      opacity: 0;
      transform: translateX(30px);
      transition: opacity 0.7s ease, transform 0.7s ease;
    }
    .js-animations .scroll-fade-right.is-visible {
      opacity: 1;
      transform: translateX(0);
    }

    .js-animations .scroll-scale {
      opacity: 0;
      transform: scale(0.95);
      transition: opacity 0.7s ease, transform 0.7s ease;
    }
    .js-animations .scroll-scale.is-visible {
      opacity: 1;
      transform: scale(1);
    }

    /* Stagger children */
    .js-animations .scroll-stagger > * {
      opacity: 0;
      transform: translateY(20px);
      transition: opacity 0.5s ease, transform 0.5s ease;
    }
    .js-animations .scroll-stagger.is-visible > *:nth-child(1) { transition-delay: 0s; opacity: 1; transform: translateY(0); }
    .js-animations .scroll-stagger.is-visible > *:nth-child(2) { transition-delay: 0.1s; opacity: 1; transform: translateY(0); }
    .js-animations .scroll-stagger.is-visible > *:nth-child(3) { transition-delay: 0.2s; opacity: 1; transform: translateY(0); }
    .js-animations .scroll-stagger.is-visible > *:nth-child(4) { transition-delay: 0.3s; opacity: 1; transform: translateY(0); }
    .js-animations .scroll-stagger.is-visible > *:nth-child(5) { transition-delay: 0.4s; opacity: 1; transform: translateY(0); }
    .js-animations .scroll-stagger.is-visible > *:nth-child(6) { transition-delay: 0.5s; opacity: 1; transform: translateY(0); }
    .js-animations .scroll-stagger.is-visible > *:nth-child(7) { transition-delay: 0.6s; opacity: 1; transform: translateY(0); }
    .js-animations .scroll-stagger.is-visible > *:nth-child(8) { transition-delay: 0.7s; opacity: 1; transform: translateY(0); }
  `;
  document.head.appendChild(style);
})();
